import React, { FC } from 'react'

//* utils
import { LocaleCodes } from '../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../models/components/announcement'
import { ComponentMainNavBanner } from '../../../models/components/mainNavBanner'
import { MenuGroup } from '../../../models/others/menuGroup'

//* components
import Layout from '../../layouts/layout'
import { Modules } from './modules'

type Props = {
  path: string
  pageContext: any
  location?: any
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  mainNavBannerData?: ComponentMainNavBanner
  browserLanguageData?: any
}

const ProductPage: FC<Props> = ({
  path,
  pageContext,
  location,
  headerData,
  footerData,
  announcementData,
  mainNavBannerData,
  browserLanguageData,
}) => {
  let pageData: any = {}
  let pageType: string = ''
  let customHeaderNavigation: any = null

  if (pageContext?.productData) {
    pageData = pageContext.productData
    customHeaderNavigation = pageData?.customHeaderNavigation
    pageType = 'product'
  } else if (pageContext?.flexData) {
    pageData = pageContext.flexData
    pageType = 'flex'
  } else if (pageContext?.solutionsData) {
    pageData = pageContext.solutionsData
    customHeaderNavigation = pageData?.customHeaderNavigation
    pageType = 'solutions'
  } else if (pageContext?.aboutRPAData) {
    pageData = pageContext.aboutRPAData
    pageType = 'aboutRPA'
  } else if (pageContext?.companyListingPageData) {
    pageData = pageContext.companyListingPageData
    pageType = 'companyListing'
  } else {
    return null
  }

  const defaultLocale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const defaultSlug = pageData?.slug || '/'

  return (
    <Layout.Template
      lang={defaultLocale}
      customNav={customHeaderNavigation}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      mainNavBannerData={mainNavBannerData}
      browserLanguageData={browserLanguageData}
      pageType={pageType}
      slug={defaultSlug}
      availableLocales={pageContext.availableLocales}>
      <Modules
        data={pageData}
        availableLocales={pageContext.availableLocales}
        locale={defaultLocale}
        slug={defaultSlug}
        pageType={pageType}
        location={location}
        path={path}
      />
    </Layout.Template>
  )
}

export default ProductPage
